import { fgFilterEntries } from "@redotech/redo-fulfillment-operations-common/views/fulfillment/fg-filter-catalog";
import RouteIcon from "@redotech/redo-icons/route.svg";
import { Provider } from "@redotech/redo-order-common/provider";
import { getProviderDisplayName } from "@redotech/redo-order-core-common/order";
import { ArrayStringFilterOperator } from "@redotech/redo-views-common/advanced-filters/array-string-filter";
import { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgFilterEntries.source;

export const OrderSourceFilter: ArrayStringTableFilter<string> = {
  type: entry.type,
  Icon: RouteIcon,
  operators: [...entry.operators],
  data: {
    name: entry.name,
    type: entry.type,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  itemLabel: "source",
  itemLabelPlural: "sources",
  values: [...entry.staticValues],
  display: (item: string) => getProviderDisplayName(item as Provider),
  displayName: entry.displayName,
};
